<div class="builder">
  <div class="builder__header d-flex align-items-center justify-content-between">
    <h4 class="builder__header__title h4">Survey builder</h4>
    <div class="builder__header__actions">
      <ng-container *ngIf="isEditMode; else viewActions">
        <button class="btn btn-light" (click)="cancel()">Cancel</button>
        <button class="btn btn-primary ml-3" [disabled]="!isChanged" (click)="onSubmit()">Save changes</button>
      </ng-container>

      <ng-template #viewActions>
        <button class="btn btn-primary ml-3" (click)="toggleEditMode()">Edit</button>
      </ng-template>
    </div>
  </div>
  <div class="builder__body" *ngIf="form; else loading">
    <form [formGroup]="form">
      <gcc-builder-item [title]="'Question'" gccValidation>
        <gcc-character-counter [withLimit]="500">
          <gcc-textarea-input
            formControlName="question"
            [isDisabled]="!isEditMode"
            [maxLength]="500"
          ></gcc-textarea-input>
        </gcc-character-counter>
      </gcc-builder-item>

      <gcc-builder-item [title]="'Yes answer'" gccValidation>
        <gcc-character-counter [withLimit]="500">
          <gcc-textarea-input
            formControlName="positive"
            [isDisabled]="!isEditMode"
            [maxLength]="500"
          ></gcc-textarea-input>
        </gcc-character-counter>
      </gcc-builder-item>

      <gcc-builder-item [title]="'No answer'">
        <div class="builder__item__header">
          <gcc-radio-group formControlName="answerType" name="type">
            <gcc-radio-button [id]="'1'" [value]="types.Single">Single answer</gcc-radio-button>
            <gcc-radio-button [id]="'2'" [value]="types.Multiple">Multiple answers</gcc-radio-button>
          </gcc-radio-group>
        </div>

        <gcc-character-counter [withLimit]="500" gccValidation>
          <gcc-textarea-input
            formControlName="negative"
            [isDisabled]="!isEditMode"
            [maxLength]="500"
          ></gcc-textarea-input>
        </gcc-character-counter>

        <div class="builder__item__option-list" formArrayName="options">
          <ng-container *ngFor="let option of options.controls; let i = index; let lst = last">
            <div [formGroupName]="i" class="form-group builder__item__option-list__item" [ngClass]="{ last: lst }">
              <span [class]="isMultiSelect() ? 'multi' : 'radio'"></span>
              <div class="builder__item__option-list__item__text">
                <gcc-character-counter [withLimit]="100" gccValidation>
                  <gcc-text-input [placeholder]="' '" [formControlName]="'text'" [maxLength]="100"></gcc-text-input>
                </gcc-character-counter>
              </div>
              <button [disabled]="!isEditMode" (click)="removeOption(i)" class="btn btn-sm">
                <i class="icon icon-delete icon-16"></i>
              </button>
            </div>
          </ng-container>

          <button [disabled]="!isEditMode" (click)="addOption()" class="btn btn-link btn-addr">
            <i class="icon icon-plus mr-1"></i>
            Add option
          </button>

          <div class="other">
            <span [class]="isMultiSelect() ? 'multi' : 'radio'"></span>
            Other
            <div class="alert alert-warning">Please note: This item is always included.</div>
          </div>
        </div>
      </gcc-builder-item>
    </form>
  </div>
  <ng-template #loading></ng-template>
</div>
